<template>
  <div class="pet-desc-page">
    <div class="sidebar-wrapper">
      <button class="hamburger" @click="sidebarOpen = !sidebarOpen">☰</button>
      <div class="sidebar" :class="{ open: sidebarOpen }">
        <div class="sidebar-header">
          <button class="close-btn" @click="sidebarOpen = false">✖</button>
          <p>{{ user.fullname }}</p>
          <p>{{ user.phone_number }}</p>
        </div>
        <ul class="sidebar-menu">

          <template v-if="user && user.user_type === 'Pet Owner'">
            <li @click="goToPage('DashboardPage')">Browse Pets</li>
            <li class="has-submenu" @click="petsOpen = !petsOpen">
              My Pets
              <span class="arrow" :class="{ 'arrow-open': petsOpen }">›</span>
            </li>
            <ul class="sub-menu" :class="{ 'sub-open': petsOpen }">
              <li @click="goToPage('YourPetsPage')">View My Pets</li>
              <li @click="goToPage('AddPetPage')">Add Pet</li>
              <li @click="goToPage('MeetingsPage')">Booking Requests</li>
            </ul>
            <li @click="goToPage('EditUserDashboard')">My Profile</li>
            <li @click="goToPage('LogoutPage')">Log Out</li>
          </template>

          <template v-else>
            <li @click="goToPage('DashboardPage')">Browse Pets</li>
            <li @click="goToPage('UsersFavouritesPage')">My Favourites</li>
            <li @click="goToPage('CalendarPage')">My Calendar</li>
            <li @click="goToPage('EditUserDashboard')">My Profile</li>
            <li @click="goToPage('LogoutPage')">Log Out</li>
          </template>

        </ul>
      </div>
    </div>

    <div class="page-wrapper" v-if="pet">
      <div class="main-card">

        <div class="profile-row">
          <img :src="backendUrl + '/pet-pics/' + pet.pet_photo" :alt="pet.pet_name" class="pet-img" />
          <div class="pet-info-col">
            <h1 class="pet-name">{{ pet.pet_name }}</h1>
            <p class="pet-breed">{{ pet.breed }}</p>
            <div class="badges-row">
              <span class="badge badge-age">{{ pet.age }}</span>
              <span class="badge" :class="pet.gender === 'Female' ? 'badge-female' : 'badge-male'">{{ pet.gender }}</span>
              <span v-if="pet.vaccinated" class="badge badge-vaccinated">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                Vaccinated
              </span>
            </div>
            <p v-if="pet.location" class="pet-location">📍 {{ pet.location }}</p>
          </div>
        </div>

        <div class="divider"></div>

        <div class="inner-section" v-if="pet.description">
          <p class="section-title">About</p>
          <p class="section-text">{{ pet.description }}</p>
        </div>

        <div class="inner-section" v-if="pet.available_start_time">
          <p class="section-title">Available Time</p>
          <div class="time-slots">
            <div class="time-slot">{{ pet.available_start_time }}</div>
            <div class="time-sep">—</div>
            <div class="time-slot">{{ pet.available_end_time }}</div>
          </div>
        </div>

        <button class="book-btn" @click="bookAppointment">
          Book an Appointment
        </button>

      </div>
    </div>

    <div class="page-wrapper" v-else>
      <p class="loading-text">Loading pet details...</p>
    </div>

  </div>
</template>


<script>
  const backendUrl = process.env.VUE_APP_API_URL
export default {
  props: ['pet', 'user'],
  data() {
    return {
      backendUrl,
      sidebarOpen: false,
      petsOpen: false,
    };
  },
  methods: {
    bookAppointment() {
      this.$emit('change-page', 'BookPetAppointmentPage', { pet: this.pet });
    },
    goToPage(pageName) {
      this.sidebarOpen = false;
      this.$emit('change-page', pageName);
    }
  },
  mounted() {
    console.log('Pet received in description page:', this.pet);
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.pet-desc-page {
  min-height: 100vh;
  background: #fffbe8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 70px 20px 40px;
}

.page-wrapper {
  width: 100%;
  max-width: 900px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.main-card {
  width: 100%;
  flex: 1;                /* ← fills all remaining vertical space */
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f0e0ff;
  padding: 40px;
  margin: 0;
  box-shadow: 0 4px 24px rgba(186, 113, 255, 0.1);
  display: flex;
  flex-direction: column;
}

/* push book button to bottom */
.book-btn {
  margin-top: auto;
  padding: 17px;
  background: #eac7ff;
  color: #4a1070;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s, transform 0.1s;
  letter-spacing: 0.01em;
  font-family: inherit;
}

.book-btn:hover  { background: #ba71ff; color: #fff; }
.book-btn:active { transform: scale(0.98); }

/* ── Profile row ── */
.profile-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 4px;
}

.pet-img {
  width: 160px;
  height: 200px;
  border-radius: 20px;
  object-fit: cover;
  border: 1px solid #f0e0ff;
  flex-shrink: 0;
  display: block;
}

.pet-info-col {
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}

.pet-name {
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.4px;
  margin: 0 0 6px;
}

.pet-breed {
  font-size: 14px;
  color: #aaa;
  font-weight: 600;
  margin: 0 0 14px;
}

/* ── Badges ── */
.badges-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.badge {
  font-size: 11px;
  font-weight: 700;
  padding: 4px 11px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.badge-age        { background: #f3eeff; color: #6d28d9; }
.badge-male       { background: #eff6ff; color: #1d4ed8; }
.badge-female     { background: #fdf2f8; color: #be185d; }
.badge-vaccinated { background: #d4f5e2; color: #1a6b3c; }

/* ── Location ── */
.pet-location {
  font-size: 13px;
  color: #aaa;
  font-weight: 600;
  line-height: 1.5;
}

/* ── Divider ── */
.divider {
  height: 1px;
  background: #f0e0ff;
  margin: 28px 0;
}

/* ── Inner sections ── */
.inner-section {
  margin-bottom: 28px;
}

.section-title {
  font-size: 12px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 10px;
}

.section-text {
  font-size: 15px;
  color: #555;
  line-height: 1.9;
  margin: 0;
}

/* ── Time slots ── */
.time-slots {
  display: flex;
  align-items: center;
  gap: 14px;
}

.time-slot {
  flex: 1;
  padding: 14px;
  background: #fffbe8;
  border: 1.5px solid #f0e0ff;
  border-radius: 14px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #4a1070;
}

.time-sep {
  font-size: 18px;
  color: #ccc;
  font-weight: 700;
  flex-shrink: 0;
}

/* ── Loading ── */
.loading-text {
  text-align: center;
  color: #aaa;
  font-size: 14px;
  padding: 40px 0;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .page-wrapper { margin: 0 auto; }
}

@media (max-width: 640px) {
  .page-wrapper { width: 100%; padding: 50px 14px 40px; }
  .main-card    { width: 100%; padding: 24px 18px; }
  .profile-row  { flex-direction: column; align-items: center; text-align: center; }
  .pet-img      { width: 100%; height: 220px; }
  .badges-row   { justify-content: center; }
  .pet-name     { font-size: 22px; }
}
</style>